require('./old.css')


var LOADER = (function(){
    var self = {};

    self.awaitingCount = 0;
    self.appendToElement = '';
    self.loadingElement = '';
    self.hideElement = '';

    self.startLoading = function( appendToElement , loadingElement , hideElement ){
        self.awaitingCount++;
        self.appendToElement = $(appendToElement);

        if(hideElement){
            self.hideElement = $(hideElement);
            self.hideElement.hide();
        }

        if(!self.loadingElement){
            self.loadingElement = $(loadingElement);
            self.appendToElement.append(
                self.loadingElement
            );
        } else {
            self.loadingElement.fadeIn();
        }

        self.loadingElement.fadeIn();

    };

    self.stopLoading = function(){
        self.awaitingCount--;
        if(self.awaitingCount == 0){
            self.loadingElement.remove();
            self.loadingElement = '';

            if(self.hideElement){
                self.hideElement.fadeIn();
            }
        }
    };

    return self;
}(LOADER));

$(document).ready(function() {
	$(".clhomemenu").addClass('height-1');

	setMenuActive();

	$('.carousel').each(function(){
        $(this).carousel({
            interval: false,
            dots: true,
            arrows: true
        });
    });

	//initialise headroom.js
	var myElement = document.querySelector("header");

	if($('#iphoneSlider').length > 0){
	    $('#iphoneSlider').slick({
			arrows: false,
	    	autoplay: true,
	  		autoplaySpeed: 1200,
	  		speed: 1200,
	  		vertical: true,
	  		infinite: false
	    });
	}

	if($('#ipadSlider').length > 0){
	    $('#ipadSlider').slick({
			arrows: false,
	    	autoplay: true,
	  		autoplaySpeed: 3000,
	  		speed: 800,
	  		fade: true
	    });
	}


    if(1 == 0 && $('.msoStatsCounters').length > 0){
	  controller = new ScrollMagic.Controller();
      var counterDisplay1 = document.getElementById("counter1");
      var counterDisplay2 = document.getElementById("counter2");
      var counterDisplay3 = document.getElementById("counter3");
      var counter1data = counterDisplay1.dataset.count;
      var counter2data = counterDisplay2.dataset.count;
      var counter3data = counterDisplay3.dataset.count;
      if(counterDisplay1.dataset.count > 50){
      	var start1 = counterDisplay1.dataset.count-50;
      	var add1 = 50;
      } else {
      	var start1 = 0;
      	var add1 = counterDisplay1.dataset.count;
      }
      if(counterDisplay2.dataset.count > 100){
      	var start2 = counterDisplay2.dataset.count-100;
      	var add2 = 100;
      } else {
      	var start2 = 0;
      	var add2 = counterDisplay2.dataset.count;
      }
      if(counterDisplay3.dataset.count > 80){
      	var start3 = counterDisplay3.dataset.count-80;
      	var add3 = 80;
      } else {
      	var start3 = 0;
      	var add3 = counterDisplay3.dataset.count;
      }
      var objCount1 = {counter: start1};
      var objCount2 = {counter: start2};
      var objCount3 = {counter: start3};

      function countItem(itemId,intCountTo,objCount){
        var strCount = "+="+intCountTo;
        var counterDisplay = document.getElementById(itemId);

        TweenLite.to(objCount, 1, {counter:strCount, roundProps:"counter", onUpdate:updateHandler, onUpdateParams:[objCount,counterDisplay], ease:Linear.easeNone});
      }

      function updateHandler(objCount, counterDisplay) {
        counterDisplay.innerHTML = objCount.counter;
      }

      //animate the counters
      var counterTween = new TimelineMax()
          .add([
              TweenLite.to(objCount1, 1, {counter:"+="+add1, roundProps:"counter", onUpdate:updateHandler, onUpdateParams:[objCount1,counterDisplay1], ease:Linear.easeNone}),
              TweenLite.to(objCount2, 2, {counter:"+="+add2, roundProps:"counter", onUpdate:updateHandler, onUpdateParams:[objCount2,counterDisplay2], ease:Linear.easeNone}),
              TweenLite.to(objCount3, 1.6, {counter:"+="+add3, roundProps:"counter", onUpdate:updateHandler, onUpdateParams:[objCount3,counterDisplay3], ease:Linear.easeNone})
        ]);

      var counterScene = new ScrollMagic.Scene({
              triggerElement: ".msoStatsTrigger",
              triggerHook: 0,
              reverse: false
          })
          .setTween(counterTween)
          .addTo(controller);
    }

    if(1 == 0 && $('.caption-banner-trigger').length > 0) {
		controller2 = new ScrollMagic.Controller();
		//animate the benefit paragraphs
		TweenLite.set('.caption-baner p', {right:'-20vw',opacity:0});
		var moveBenefitsTween = new TimelineMax()
		  .add([
		      TweenLite.to(".caption-baner p:nth-of-type(1)", 0.8, {right: 0, delay: 0.0, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(2)", 0.8, {right: 0, delay: 0.2, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(3)", 0.8, {right: 0, delay: 0.4, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(4)", 0.8, {right: 0, delay: 0.6, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(5)", 0.8, {right: 0, delay: 0.8, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(6)", 0.8, {right: 0, delay: 1.0, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(7)", 0.8, {right: 0, delay: 1.2, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(8)", 0.8, {right: 0, delay: 1.4, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(9)", 0.8, {right: 0, delay: 1.6, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),
		      TweenLite.to(".caption-baner p:nth-of-type(10)", 0.8, {right: 0, delay: 1.8, ease: new Ease(BezierEasing(0.175, 0.185, 0.32, 1.575))}),

		      TweenLite.to(".caption-baner p:nth-of-type(1)", 0.8, {opacity: 1, delay: 0.0, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(2)", 0.8, {opacity: 1, delay: 0.2, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(3)", 0.8, {opacity: 1, delay: 0.4, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(4)", 0.8, {opacity: 1, delay: 0.6, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(5)", 0.8, {opacity: 1, delay: 0.8, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(6)", 0.8, {opacity: 1, delay: 1.0, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(7)", 0.8, {opacity: 1, delay: 1.2, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(8)", 0.8, {opacity: 1, delay: 1.4, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(9)", 0.8, {opacity: 1, delay: 1.6, ease: Linear.easeNone}),
		      TweenLite.to(".caption-baner p:nth-of-type(10)", 0.8, {opacity: 1, delay: 1.8, ease: Linear.easeNone})
		]);
		var moveBenefits = new ScrollMagic.Scene({
		      triggerElement: ".caption-banner-trigger",
		      triggerHook: 0,
		      reverse: true
		  })
		  .setTween(moveBenefitsTween)
		  .addTo(controller2);
    }
});

function setMenuActive() {
    var path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);

    if(path != "") {
    	$('.main-menu-item').each(function () {
	    	$(this).removeClass('active');
	    });
     	$('.main-menu-item').each(function () {
	        var href = $(this).attr('href');
	    	if (path === href) {
	           	$(this).addClass('active');
	        }
	    });
    }

    if(path.search('models') > 0) {
    	$('.main-menu-item[href="/models"]').addClass('active');
	}
	var release = '';
	var environment = $('html').data('environment');
	if ( environment != 'development' ) {
		release =  $('html').data('rls');
		Sentry.init({
			dsn: 'https://f64958637df84a658d67e35b6eb2819b@sentry.io/128370',
			release: release,
			environment: environment,
			ignoreErrors: [
				'can\'t redefine non-configurable property "userAgent"',
				/null is not an object \(evaluating '[A-z].title'\)/,
				'ResizeObserver loop limit exceeded',
				'QuotaExceededError: The quota has been exceeded.',
				"Can't find variable: MutationObserver",
				"MutationObserver is not defined",
				/LP_explicit_ignored/,
				/__show__deepen/,
				/Can't find variable: MyAppGet/,
				/^vivoNews/,
				/^vivo_/,
				/__firefox__/,
				/AbortError/

			],
			whitelistUrls: [
				/(?:www|test)\.(?:art-lingerie|layered-nylons|onlytease|only-opaques|only-secretaries|onlysilkandsatin|only-sportswear|only-costumes|onlyallsites)\./i,
				/(?:p|t)\.oas\.me/i
			],
			async beforeSend(event, hint) {
				try {
					if ( event?.request?.url.match(/fbclid=/) && event.exception.values[0].value.match(/Illegal invocation/i) ) {	
						// Handling FB causing errors with LazyLoad
						return null
					}

					if (event.exception.values[0].value.match( /isTrusted/i ) ) {
						// Useless error	
						return null
					}
					let rls = await fetch('/main/releasehash').catch( (r) => {
						console.log(r)
					} )				
					
					let evtrelease = event.release || ''
					if ( rls && rls.ok && rls.status == 200 ) {
						let release = await rls.text()
						if ( release != evtrelease ) {
							console.log( release + " doesn't match " + evtrelease )
							alert( "Your session has timed out, click ok and refresh the page to try again, if this message persists, please try clearing your browser cache." )
							return null
						}
					}
				} catch ( e ) {
					console.log(e)
					return event	
				}
				return event
			}
		});
	}
}

$(document).on("click",".navbar-header .navbar-toggle", function(event) {
	$("#homemenu").removeClass('height-1');
});

$(document).on('mouseenter', '.models-img-needview', function () {
 	$(this).children('.models-button-view').css({
 		width: $(this).children('img').width()
 	});
 	$(this).children('.models-button-view').show();
});

$(document).on('mouseleave', '.models-img-needview', function () {
 	$(this).children('.models-button-view').hide();
});

$(document).on('click', '.tab-oo', function () {
	$('.other-sites-img-container').css("border-bottom", "10px solid #ec008c");
})

$(document).on('click', '.tab-os', function () {
	$('.other-sites-img-container').css("border-bottom", "10px solid #623F91");
})

$(document).on('click', '.tab-oss', function () {
	$('.other-sites-img-container').css("border-bottom", "10px solid #94B55C");
})


;(function() {
	var page = 1;
	var month, year;
	const queryString = require("query-string")

	$(document).ready(function () {
		var date = new Date();

		var m = date.getMonth() + 1;

		if ( $('#listModels').data('month') ) {
			m = $('#listModels').data('month')
		}
		$('.dek-search-month').each(function () {
			if($(this).attr('data-month') == m) {
				$(this).addClass('filter-active-month site_sec_bg_color');
				month = m;
			}
		})
		let queryparams = queryString.parse( window.location.search )

		if ( queryparams['loadExtra'] ) {
			page +=1;
		}

		ImageMatchHeight();

        if ( !('customElements' in window ) && document.getElementById("oldbrowser")) {
            document.getElementById("oldbrowser").style.display = "block";
        }
	});

	$(document).on('click',".updates-section-loadmore #loadMore",function(e){
		e.preventDefault();
		loadMoreUpdates();
	});
	$(document).on('click',".updates-section-loadmore #loadMoreArchived",function(e){
		e.preventDefault();
		page++;

		month = $('#moblie-month-select option:selected').val();
		year = $('#moblie-year-select option:selected').val();

		if(month == 0 && year == 0){
			month =$('.filter-active-month').attr('data-month');
			year = $('.filter-active-year').attr('data-year');
		}

		loadMoreArchived(page);
	});


	$(document).on('click',".searchbytime",function(e){
		e.preventDefault();
	});

	$(document).on('click',".search-month",function(e){
		$('.search-month').each(function(){
			$(this).removeClass('filter-active-month site_sec_bg_color');
		});
		$(this).addClass('filter-active-month site_sec_bg_color');
	});

	$(document).on('click',".search-year",function(){
		$('.search-year').each(function(){
			$(this).removeClass('filter-active-year site_sec_bg_color');
		});
		$(this).addClass('filter-active-year site_sec_bg_color');
	});

	$(document).on('click',"#search-archive-desktop",function(e){
		e.preventDefault();
		month = $('.filter-active-month').attr('data-month');
		year = $('.filter-active-year').attr('data-year');
		page = 1;
		$('html, body').animate({
			scrollTop: $("#search").offset().top
		}, 500);
		searchArchive();
	});

	$(document).on('click',"#search-archive-mobile",function(e){
		e.preventDefault();
		month = $('#moblie-month-select option:selected').val();
		year = $('#moblie-year-select option:selected').val();
		page = 1;
		$('html, body').animate({
			scrollTop: $("#search").offset().top
		}, 500);

		$('#moblie-month-select').text($('#moblie-month-select option:selected').attr('month-name'));
		searchArchive();
	});

	function loadMoreUpdates(){
		LOADER.startLoading(
			'.updates-section-loadmore',
			'<div class="row site_text_color updates-loading-spin" id="loading"><div class="col-md-12"><i class="fa fa-spinner fa-spin fa-2x"></i></div></div>',
			'#div_loadmore'
		);
		var modelsList = $('#listModels');
		var url = modelsList.data('url');

		page++;

		$.ajax({
			type: "GET",
			url:  url,
			data : {
				page: page
			},
			dataType: "html",
			success: function (data) {
				LOADER.stopLoading();
				modelsList.append(data);
				ImageMatchHeight();
			},
			error: function () {

			}
		});
	}

	function loadMoreArchived(  page , replaceLoad ){
		LOADER.startLoading(
			'#listModels',
			'<div class="row site_sec_text_color search-loading-spin" id="loading"><div class="col-md-12"><i class="fa fa-spinner fa-spin fa-2x"></i></div></div>',
			'#div_loadmore'
		);
		var modelsList = $('#listModels');
		var loadMore = $('#div_loadmore');
		var url = modelsList.data('archive-url') + '/?page=' + page +'&intYear=' + year + '&intMonth=' + month ;

		$.get(url).done(function (data) {
			LOADER.stopLoading();

			if(replaceLoad){
				modelsList.empty();
				loadMore.replaceWith('<div class="col-md-12" id="div_loadmorearchived"><a href="##" class="site_sec_bg_color button-pink  updates-loadmore btn-filter-archive" id="loadMoreArchived">Load More</a></div>');
			}

			modelsList.append(data);

			ImageMatchHeight()
		});

	}

	function searchArchive(  ){
		window.history.pushState( { intYear: year, intMonth: month }, '', '/updates/archive/' + year + '/' + month )
		loadMoreArchived( 1 , true )
	}

	function ImageMatchHeight(){

		/*$('.item-row .personalContent > p').matchHeight(
			{
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			}
		);*/
	}

	window.addEventListener('popstate',  function(e){

		if( e.state && e.state.intYear) {
			var modelsList = $('#listModels');
			year = e.state.intYear
			month = e.state.intMonth
			page = 1
			modelsList.empty()
			$('.filter-active-month').attr('data-month', month)
			$('.filter-active-year').attr('data-year', year)
			loadMoreArchived( page, false )
			$('html, body').animate({
				scrollTop: $("#search").offset().top
			}, 500);
		}
	});
})()

;(function() {

	var page = 1;
	var limit = 12;
	var strFilter = $('#strFilter').val();

	$(window).on('scroll', function (e) {
		var autoLoadMore = $(".models-section-loadmore.autoload");
		if ( autoLoadMore.length ) {
			var theButton = autoLoadMore.find('#loadmore');
			var offset = autoLoadMore.offset();
			if ( window.scrollY > (offset.top - ( window.innerHeight + 50) ) && theButton.is(":visible") ) {
				autoLoadMore.find('#loadmore').click();

			}
		}
	});

	$(document).on('click',".models-section-loadmore #loadmore",function(e){
		e.preventDefault();
		var isSets = false;
		if ( document.querySelector("#listSets") ) {
			isSets = true;
		}

		LOADER.startLoading(
			isSets ? '#listSets' : '#listModels',
			'<div class="row site_text_color updates-loading-spin" id="loading"><div class="col-md-12"><i class="fa fa-spinner fa-spin fa-2x"></i></div></div>',
			'#div_loadmore'
		);
		if ( isSets ) {
			loadMoreProfile();
		} else {
			loadMoreModels();
		}
	});

	$(document).on('click',".filter",function(e){
		e.preventDefault();
		document.getElementById('loadmore').classList.remove('hidden')
		$('#listModels').empty();
		$('html, body').animate({
			scrollTop: $("#filter").offset().top
		}, 500);

		strFilter = $(this).attr('data-filter');
		page = 0;


		LOADER.startLoading(
			'#listModels',
			'<div class="row site_text_color updates-loading-spin" id="loading"><div class="col-md-12"><i class="fa fa-spinner fa-spin fa-2x"></i></div></div>',
			'#div_loadmore'
		);
		loadMoreModels(true);

		window.history.pushState( { filter: $( e.target ).data('filter') }, '', $( e.target ).attr('href') );
	});

	function loadMoreModels(emptyContainer){
		var modelsList = $('#listModels');

		$('.filter').each(function(){
			$(this).parent().removeClass('active');
			if($(this).attr('data-filter') == strFilter){
				$(this).parent().addClass('active');
			}
		});
		var url = modelsList.data('url') + '/?page=' + page + '&limit=' + limit + "&filter=" + strFilter;

		page++;

		$.get(url).done(function (data) {
			if(emptyContainer){
				$('#listModels').empty();
			}
			$('#listModels').append(data);
			LOADER.stopLoading();
			if(strFilter.length == 0){
				$('#div_loadmore').hide();
			}
		});

	}

	window.addEventListener('popstate',  function(e){

		if(e.state && e.state.filter){
			strFilter = e.state.filter
			page = 0
			console.log("filter: " + strFilter );

			LOADER.startLoading(
				'#listModels',
				'<div class="row site_text_color updates-loading-spin" id="loading"><div class="col-md-12"><i class="fa fa-spinner fa-spin fa-2x"></i></div></div>',
				'#div_loadmore'
			);
			loadMoreModels(true);
		}
	});
	
})()

var page = 1;
var limit = 12;



$(document).ready(function () {

    if($('.tabs-other-sites-ul').length > 0 ) {
        $('.tabs-other-sites-ul').children('li').first().addClass('active');

        var $curTab = $('.tabs-other-sites-ul').children('li').first();

        if($curTab.hasClass('tab-oo')) {
            $('.other-sites-img-container').css("border-bottom", "10px solid #ec008c");
        }
        if($curTab.hasClass('tab-os'))  {
            $('.other-sites-img-container').css("border-bottom", "10px solid #623F91");
        }

        if($curTab.hasClass('tab-oss'))  {
            $('.other-sites-img-container').css("border-bottom", "10px solid #94B55C");
        }
    }

    if($('.tab-content-other-site').length > 0 ) {
        $('.tab-content-other-site').first().addClass('active');
    }

    if($('.tabs-other-sites-ul-mobi').length > 0 ) {
        $('.tabs-other-sites-ul-mobi').children('li').first().addClass('active');
    }

    if($('.tab-content-other-site-mobi').length > 0 ) {
        $('.tab-content-other-site-mobi').first().addClass('active');
    }
});

function loadMoreProfile(){
	var strFilter = $('#strFilter').val();
    $.ajax({
        type: "post",
        url:  "/models/loadMoreProfile",
        data: {
            'page':page++,
            'limit':limit,
            'strFilter':strFilter
        },
        dataType: "html",
        success: function (data) {
        	$('#listSets').append(data);
        	LOADER.stopLoading();
        	/*
            if(limit == 8){
                $('#div_loadmore_mobile').show();
            }else{
                $('#div_loadmore_desktop').show();
            }*/
        },
        error: function () {

        }
    });
}



// WEBPACK FOOTER //
// ./widgets/old/index.js